import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { Config } from './config'
import type { Plugin } from './plugin'

export class Selectors<TTypeParams extends ec.models.TypeParams.Constraint> {
  /**
   * Indicates if our {@link Config.clipboardService} has any items that
   * satisfies {@link Config.pasteClassRef} constraints.
   */
  public readonly canPaste

  constructor(plugin: Plugin<TTypeParams>) {
    this.canPaste = plugin.config.clipboardService.canPaste({
      pasteClassRef: plugin.config.pasteClassRef,
    })
  }
}
